import { useCallback } from 'react';
import { Checkbox, Radio } from '@material-ui/core';
import { SELECTIONMODE_SINGLE, SELECTIONMODE_MULTI, useSelection, useSelectionActions } from '../SelectionContext';
import { useDataStore } from '../DataStore';

/* eslint-disable react/prop-types */

function SelectionHeader() {
    const { hasSelection, allSelected, allowSelectAll, mode } = useSelection();
    const { selectAll, deselectAll } = useSelectionActions();
    const { rows } = useDataStore();
    const onChange = useCallback(
        (event) => {
            return event.target.checked ? selectAll(rows) : deselectAll();
        },
        [selectAll, deselectAll, rows]
    );

    return (
        <>
            {mode === SELECTIONMODE_MULTI && (
                <Checkbox
                    indeterminate={hasSelection && !allSelected}
                    checked={hasSelection && allSelected}
                    color="default"
                    size="small"
                    disabled={!allowSelectAll}
                    onClick={onChange}
                />
            )}
        </>
    );
}

function SelectionValue(props) {
    const { row } = props;
    const { isSelected, mode } = useSelection();

    const SelectionCmp = mode === SELECTIONMODE_SINGLE ? Radio : Checkbox;

    return <SelectionCmp color="default" size="small" checked={isSelected(row)} />;
}

export function selectionRenderer(row) {
    return <SelectionValue row={row} />;
}

export function selectionHeaderRenderer() {
    return <SelectionHeader />;
}
